
export const backend_url = "https://ppd.geoint.mx/apidev"
